import { data } from '../../svg/Menu/data';
import { makeIcon } from '../makeIcon';

export const Menu = makeIcon(data, 'menu', 'Menu');

export default Menu;
